module.exports = __webpack_public_path__ + "static/media/evMetaImage.478d8e77.png";